import { Routes } from '@angular/router';

export const harnessRoutes: Routes = [];
